// import * as React from "react";
// import {
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   Card,
//   TextField,
//   Button,
//   Grid,
//   IconButton,
//   Stack,
//   Tooltip,
//   Typography,
//   Chip,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   CircularProgress,
// } from "@mui/material";
// import {
//   Add as AddIcon,
//   Delete as DeleteIcon,
//   Visibility as ViewIcon,
//   CheckCircle as AcceptIcon,
//   Cancel as RejectIcon,
//   Pending as PendingIcon,
//   Badge as BadgeIcon,
//   Email as EmailIcon,
//   Download as DownloadIcon,
// } from "@mui/icons-material";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import swal from "sweetalert";
// import MainCard from "ui-component/cards/MainCard";
// import { gridSpacing } from "store/constant";
// import { useDebounce } from "hooks/useDebounced";

// export default function VisitorGatePass() {
//   const navigate = useNavigate();
//   const [page, setPage] = useState(0);
//   const [search, setSearch] = useState("");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const [rowsPerPage, setRowsPerPage] = useState(10);
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [sendingPass, setSendingPass] = useState(false);
//   const [updatingStatus, setUpdatingStatus] = useState({});
//   const [downloading, setDownloading] = useState({});

//   const debouncedSearch = useDebounce(search, 1000);

//   // ✅ Fetch visitor gate pass list
//   const fetchVisitorGatePasses = async () => {
//     setLoading(true);
//     try {
//       const queryParams = new URLSearchParams({
//         page: page + 1,
//         limit: rowsPerPage,
//         search,
//         status: statusFilter,
//       });

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/visitor-gatepass-list?${queryParams}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         setRows(result.data.visitorGatePasses || []);
//         setTotal(result.data.pagination?.total || 0);
//       } else {
//         toast.error(result.message || "Failed to fetch visitor gate passes");
//         setRows([]);
//         setTotal(0);
//       }
//     } catch (error) {
//       console.error("Error fetching visitor gate passes:", error);
//       toast.error("Something went wrong while fetching visitor gate passes");
//       setRows([]);
//       setTotal(0);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchVisitorGatePasses();
//   }, [page, rowsPerPage, debouncedSearch, statusFilter]);

//   // ✅ Pagination
//   const handleChangePage = (event, newPage) => setPage(newPage);
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };
//   const handleStatusFilter = (event) => {
//     setStatusFilter(event.target.value);
//     setPage(0);
//   };

//   // ✅ Update visitor gate pass status
//   const updateVisitorStatus = async (id, newStatus, name) => {
//     if (updatingStatus[id]) return;

//     const actionText = newStatus === "accept" ? "Accept" : "Reject";

//     swal({
//       title: `${actionText} ${name}?`,
//       text: `Are you sure you want to ${actionText.toLowerCase()} this visitor gate pass?`,
//       icon: newStatus === "accept" ? "success" : "error",
//       buttons: ["Cancel", actionText],
//       dangerMode: newStatus === "reject",
//     }).then(async (willProceed) => {
//       if (!willProceed) return;

//       try {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/update-visitor-gatepass-status/${id}`,
//           {
//             method: "PUT",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ status: newStatus }),
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success(`Visitor Gate Pass ${actionText}ed successfully`);
//           setRows((prev) =>
//             prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item))
//           );
//         } else {
//           toast.error(result.message || `Failed to ${actionText.toLowerCase()} gate pass`);
//         }
//       } catch (error) {
//         console.error("Error updating visitor status:", error);
//         toast.error("Something went wrong while updating visitor gate pass");
//       } finally {
//         setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
//       }
//     });
//   };

//   // ✅ Send gate pass email
//   const sendVisitorGatePass = async (id, name) => {
//     setSendingPass(true);
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/send-visitor-gate-pass/${id}`,
//         {
//           method: "POST",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       const result = await response.json();

//       if (result.code === 200) {
//         toast.success(`Visitor gate pass sent successfully to ${name}`);
//       } else {
//         toast.error(result.message || "Failed to send visitor gate pass");
//       }
//     } catch (error) {
//       console.error("Error sending visitor gate pass:", error);
//       toast.error("Something went wrong while sending visitor gate pass");
//     } finally {
//       setSendingPass(false);
//     }
//   };

//   const handleDownload = async (id, visitorId) => {
//     if (downloading[id]) return;

//     setDownloading((prev) => ({ ...prev, [id]: true }));

//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/download-gatepass-temp-visitor/${id}`,
//         {
//           method: "GET",
//           headers: {
//             authkey: process.env.REACT_APP_AUTH_KEY,
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Download failed:", errorText);
//         toast.error("Failed to download gate pass");
//         return;
//       }

//       // ✅ Check if response has content
//       const contentType = response.headers.get("content-type");
//       if (!contentType || !contentType.includes("application/pdf")) {
//         console.error("Invalid content type:", contentType);
//         toast.error("Invalid PDF response");
//         return;
//       }

//       const blob = await response.blob();

//       // ✅ Verify blob has content
//       if (blob.size === 0) {
//         console.error("Empty PDF received");
//         toast.error("Empty PDF file");
//         return;
//       }

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `GatePass_${visitorId}.pdf`;
//       document.body.appendChild(a);
//       a.click();

//       // ✅ Cleanup after a short delay
//       setTimeout(() => {
//         window.URL.revokeObjectURL(url);
//         document.body.removeChild(a);
//         toast.success("Gate pass downloaded successfully");
//       }, 100);
//     } catch (error) {
//       console.error("Error downloading gate pass:", error);
//       toast.error("Something went wrong while downloading gate pass");
//     } finally {
//       setDownloading((prev) => ({ ...prev, [id]: false }));
//     }
//   };

//   // ✅ Delete visitor gate pass
//   const deleteVisitorGatePass = (id, name) => {
//     swal({
//       title: `Delete ${name}?`,
//       text: "This will permanently delete this visitor gate pass record!",
//       icon: "warning",
//       buttons: ["Cancel", "Delete"],
//       dangerMode: true,
//     }).then(async (willDelete) => {
//       if (!willDelete) return;

//       try {
//         const response = await fetch(
//           `${process.env.REACT_APP_API_URL}/delete-visitor-gatepass/${id}`,
//           {
//             method: "DELETE",
//             headers: {
//               authkey: process.env.REACT_APP_AUTH_KEY,
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//               "Content-Type": "application/json",
//             },
//           }
//         );

//         const result = await response.json();

//         if (result.code === 200) {
//           toast.success("Visitor gate pass deleted successfully");
//           setRows((prev) => prev.filter((item) => item._id !== id));
//           setTotal((prev) => prev - 1);
//         } else {
//           toast.error(result.message || "Failed to delete visitor gate pass");
//         }
//       } catch (error) {
//         console.error("Error deleting visitor gate pass:", error);
//         toast.error("Something went wrong while deleting visitor gate pass");
//       }
//     });
//   };

//   // ✅ Status chip UI
//   const getStatusChip = (status) => {
//     const statusConfig = {
//       pending: { color: "warning", icon: <PendingIcon />, label: "Pending" },
//       accept: { color: "success", icon: <AcceptIcon />, label: "Accepted" },
//       reject: { color: "error", icon: <RejectIcon />, label: "Rejected" },
//     };
//     const config = statusConfig[status] || statusConfig.pending;

//     return (
//       <Chip
//         icon={config.icon}
//         label={config.label}
//         color={config.color}
//         size="small"
//         variant="outlined"
//       />
//     );
//   };

//   const formatDate = (dateString) =>
//     new Date(dateString).toLocaleDateString("en-IN", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });

//   return (
//     <>
//       <Grid container spacing={2} sx={{ mb: 2 }}>
//         <Grid item xs={12} sm={6} md={4}>
//           <TextField
//             fullWidth
//             label="Search visitor gate passes..."
//             type="search"
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             placeholder="Name, company, purpose..."
//           />
//         </Grid>
//         <Grid item xs={12} sm={6} md={3}>
//           <FormControl fullWidth>
//             <InputLabel>Status Filter</InputLabel>
//             <Select value={statusFilter} onChange={handleStatusFilter} label="Status Filter">
//               <MenuItem value="all">All Status</MenuItem>
//               <MenuItem value="pending">Pending</MenuItem>
//               <MenuItem value="accept">Accepted</MenuItem>
//               <MenuItem value="reject">Rejected</MenuItem>
//             </Select>
//           </FormControl>
//         </Grid>
//       </Grid>

//       <MainCard
//         title={
//           <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
//             <Grid item>
//               <Typography variant="h3">Temporary Visitor Gate Pass ({total} total)</Typography>
//             </Grid>
//             <Grid item>
//             </Grid>
//           </Grid>
//         }
//         content={false}
//       >
//         <Card>
//           <Paper sx={{ width: "100%", overflow: "hidden" }}>
//             <TableContainer sx={{ maxHeight: 600 }}>
//               <Table stickyHeader aria-label="visitor gate pass table">
//                 <TableHead>
//                   <TableRow>
//                     <TableCell>S. No.</TableCell>
//                     <TableCell>Gate Pass ID</TableCell>
//                     <TableCell>HOD Name</TableCell>
//                     <TableCell>Company</TableCell>
//                     <TableCell>Department</TableCell>
//                     <TableCell>Contact</TableCell>
//                     <TableCell>Entry Time</TableCell>
//                     <TableCell>HOD Status</TableCell>
//                     <TableCell>Status</TableCell>
//                     <TableCell align="center">Actions</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {loading ? (
//                     <TableRow>
//                       <TableCell colSpan={9} align="center">
//                         <Typography>Loading...</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : rows.length === 0 ? (
//                     <TableRow>
//                       <TableCell colSpan={9} align="center">
//                         <Typography>No visitor gate passes found</Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     rows.map((row, index) => (
//                       <TableRow hover key={row._id}>
//                         <TableCell>{page * rowsPerPage + index + 1}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold" color="primary">
//                             {row.visitorId}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="body2" fontWeight="bold">
//                             {row.staff.name}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{row.companyName || "N/A"}</TableCell>
//                         <TableCell>{row.department.name || "N/A"}</TableCell>
//                         <TableCell>
//                           <Typography variant="body2">{row.mobile}</Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             {row.email}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>
//                           <Typography variant="caption" display="block">
//                             From: {formatDate(row.visitStart)}
//                           </Typography>
//                           <Typography variant="caption" color="textSecondary">
//                             To: {formatDate(row.visitEnd)}
//                           </Typography>
//                         </TableCell>
//                         <TableCell>{getStatusChip(row.staff_status)}</TableCell>
//                         <TableCell>{getStatusChip(row.status)}</TableCell>
//                         <TableCell align="center">
//                           <Stack direction="row" spacing={0.5} justifyContent="center">
//                             <Tooltip title="View Details">
//                               <IconButton
//                                 size="small"
//                                 color="info"
//                                 onClick={() => navigate(`/visitor-gatepass/${row._id}`)}
//                               >
//                                 <ViewIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>

//                             {row.status === "pending" && (
//                               <>
//                                 <Tooltip title="Accept">
//                                   <IconButton
//                                     size="small"
//                                     color="success"
//                                     onClick={() =>
//                                       updateVisitorStatus(
//                                         row._id,
//                                         "accept",
//                                         row.visitor.fullName
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     {updatingStatus[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <AcceptIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>

//                                 <Tooltip title="Reject">
//                                   <IconButton
//                                     size="small"
//                                     color="error"
//                                     onClick={() =>
//                                       updateVisitorStatus(
//                                         row._id,
//                                         "reject",
//                                         row.visitor.fullName
//                                       )
//                                     }
//                                     disabled={!!updatingStatus[row._id]}
//                                   >
//                                     <RejectIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             {row.status === "accept" && (
//                               <>
//                                 <Tooltip title="Send Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="primary"
//                                     onClick={() =>
//                                       sendVisitorGatePass(row._id, row.visitor.fullName)
//                                     }
//                                     disabled={sendingPass}
//                                   >
//                                     <EmailIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                                 <Tooltip title="Download Gate Pass">
//                                   <IconButton
//                                     size="small"
//                                     color="secondary"
//                                     onClick={() => handleDownload(row._id, row.visitorId)}
//                                     disabled={!!downloading[row._id]}
//                                   >
//                                     {downloading[row._id] ? (
//                                       <CircularProgress size={16} />
//                                     ) : (
//                                       <DownloadIcon fontSize="small" />
//                                     )}
//                                   </IconButton>
//                                 </Tooltip>
//                               </>
//                             )}

//                             <Tooltip title="Delete">
//                               <IconButton
//                                 size="small"
//                                 color="error"
//                                 onClick={() =>
//                                   deleteVisitorGatePass(row._id, row.visitor.fullName)
//                                 }
//                               >
//                                 <DeleteIcon fontSize="small" />
//                               </IconButton>
//                             </Tooltip>
//                           </Stack>
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </TableContainer>
//             <TablePagination
//               rowsPerPageOptions={[5, 10, 25, 50]}
//               component="div"
//               count={total}
//               rowsPerPage={rowsPerPage}
//               page={page}
//               onPageChange={handleChangePage}
//               onRowsPerPageChange={handleChangeRowsPerPage}
//             />
//           </Paper>
//         </Card>
//       </MainCard>
//     </>
//   );
// }

import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Card,
  TextField,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  CheckCircle as AcceptIcon,
  Cancel as RejectIcon,
  Pending as PendingIcon,
  Email as EmailIcon,
  Download as DownloadIcon,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import swal from "sweetalert";
import MainCard from "ui-component/cards/MainCard";
import { gridSpacing, PASS_STATUS } from "store/constant";
import { useDebounce } from "hooks/useDebounced";
import { useTranslation } from "react-i18next";

export default function VisitorGatePass() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sendingPass, setSendingPass] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState({});
  const [downloading, setDownloading] = useState({});
  const debouncedSearch = useDebounce(search, 1000);

  // Fetch visitor gate passes
  const fetchVisitorGatePasses = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: page + 1,
        limit: rowsPerPage,
        search,
        status: statusFilter,
      });

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}visitor-gatepass-list?${queryParams}`,
        {
          method: "GET",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        setRows(result.data.visitorGatePasses || []);
        setTotal(result.data.pagination?.total || 0);
      } else {
        toast.error(result.message || t("VisitorGatePass.fetchFailed"));
        setRows([]);
        setTotal(0);
      }
    } catch (error) {
      console.error("Error fetching visitor gate passes:", error);
      toast.error(t("VisitorGatePass.somethingWentWrong"));
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisitorGatePasses();
  }, [page, rowsPerPage, debouncedSearch, statusFilter]);

  // Pagination
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilter = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // Update status
  // const updateVisitorStatus = async (id, newStatus, name) => {
  //   if (updatingStatus[id]) return;
  //   const actionText =
  //     newStatus === "accept" ? t("VisitorGatePass.accept") : t("VisitorGatePass.reject");

  //   swal({
  //     title: `${actionText} ${name}?`,
  //     text: t("VisitorGatePass.confirmStatusChange", { action: actionText.toLowerCase() }),
  //     icon: newStatus === "accept" ? "success" : "error",
  //     buttons: [t("VisitorGatePass.cancel"), actionText],
  //     dangerMode: newStatus === "reject",
  //   }).then(async (willProceed) => {
  //     if (!willProceed) return;
  //     try {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

  //       const response = await fetch(
  //         `${process.env.REACT_APP_API_URL}update-visitor-gatepass-status/${id}`,
  //         {
  //           method: "PUT",
  //           headers: {
  //             authkey: process.env.REACT_APP_AUTH_KEY,
  //             Authorization: `Bearer ${localStorage.getItem("token")}`,
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify({ status: newStatus }),
  //         },
  //       );

  //       const result = await response.json();
  //       if (result.code === 200) {
  //         toast.success(t("VisitorGatePass.statusUpdated", { action: actionText }));
  //         setRows((prev) =>
  //           prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
  //         );
  //       } else {
  //         toast.error(
  //           result.message || t("VisitorGatePass.statusUpdateFailed", { action: actionText }),
  //         );
  //       }
  //     } catch (error) {
  //       console.error("Error updating visitor status:", error);
  //       toast.error(t("VisitorGatePass.somethingWentWrong"));
  //     } finally {
  //       setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
  //     }
  //   });
  // };

  // Send gate pass
  // const sendVisitorGatePass = async (id, name) => {
  //   setSendingPass(true);
  //   try {
  //     const response = await fetch(`${process.env.REACT_APP_API_URL}send-visitor-gate-pass/${id}`, {
  //       method: "POST",
  //       headers: {
  //         authkey: process.env.REACT_APP_AUTH_KEY,
  //         Authorization: `Bearer ${localStorage.getItem("token")}`,
  //         "Content-Type": "application/json",
  //       },
  //       body: JSON.stringify({ lang: localStorage.getItem("lang") }),
  //     });

  //     const result = await response.json();
  //     if (result.code === 200) {
  //       toast.success(t("VisitorGatePass.gatePassSent", { name }));
  //     } else {
  //       toast.error(result.message || t("VisitorGatePass.gatePassSendFailed"));
  //     }
  //   } catch (error) {
  //     console.error("Error sending visitor gate pass:", error);
  //     toast.error(t("VisitorGatePass.somethingWentWrong"));
  //   } finally {
  //     setSendingPass(false);
  //   }
  // };

  const updateVisitorStatus = async (id, newStatus, name) => {
    if (updatingStatus[id]) return;

    // Step 1: Choose language
    const langChoice = await swal({
      title: t("VisitorGatePass.chooseLanguageTitle"),
      text: t("VisitorGatePass.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    const actionText =
      newStatus === "accept" ? t("VisitorGatePass.accept") : t("VisitorGatePass.reject");

    // Step 2: Confirm action
    const willProceed = await swal({
      title: `${actionText} ${name}?`,
      text: t("VisitorGatePass.confirmStatusChange", {
        action: actionText.toLowerCase(),
      }),
      icon: newStatus === "accept" ? "success" : "error",
      buttons: [t("visitorGatePass.confirm.cancel"), actionText],
      dangerMode: newStatus === "reject",
    });

    if (!willProceed) return;

    try {
      setUpdatingStatus((prev) => ({ ...prev, [id]: true }));

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}update-visitor-gatepass-status/${id}`,
        {
          method: "PUT",
          headers: {
            authkey: process.env.REACT_APP_AUTH_KEY,
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            status: newStatus,
            lang: langChoice, // ✅ explicit language
          }),
        },
      );

      const result = await response.json();

      if (result.code === 200) {
        toast.success(t("VisitorGatePass.statusUpdated", { action: actionText }));

        setRows((prev) =>
          prev.map((item) => (item._id === id ? { ...item, status: newStatus } : item)),
        );
      } else {
        toast.error(
          result.message || t("VisitorGatePass.statusUpdateFailed", { action: actionText }),
        );
      }
    } catch (error) {
      console.error("Error updating visitor status:", error);
      toast.error(t("VisitorGatePass.somethingWentWrong"));
    } finally {
      setUpdatingStatus((prev) => ({ ...prev, [id]: false }));
    }
  };

  const sendVisitorGatePass = async (id, name) => {
    const langChoice = await swal({
      title: t("VisitorGatePass.chooseLanguageTitle"),
      text: t("VisitorGatePass.chooseLanguageText"),
      icon: "info",
      buttons: {
        en: {
          text: t("Common.languageEnglish"),
          value: "en",
        },
        ar: {
          text: t("Common.languageArabic"),
          value: "ar",
        },
      },
    });

    if (!langChoice) return;

    setSendingPass(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}send-visitor-gate-pass/${id}`, {
        method: "POST",
        headers: {
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ lang: langChoice }),
      });

      const result = await response.json();
      if (result.code === 200) {
        toast.success(t("VisitorGatePass.gatePassSent", { name }));
      } else {
        toast.error(result.message || t("VisitorGatePass.gatePassSendFailed"));
      }
    } catch (error) {
      console.error("Error sending visitor gate pass:", error);
      toast.error(t("VisitorGatePass.somethingWentWrong"));
    } finally {
      setSendingPass(false);
    }
  };

  // Download gate pass or details
  const handleDownload = async (id, visitorId) => {
    const choice = await swal({
      title: t("VisitorGatePass.downloadOptions.title"),
      text: t("VisitorGatePass.downloadOptions.text"),
      icon: "info",
      buttons: {
        // cancel: t("VisitorGatePass.downloadOptions.cancel"),
        gatepass: {
          text: t("VisitorGatePass.downloadOptions.gatePass"),
          value: "gatepass",
        },
        details: {
          text: t("VisitorGatePass.downloadOptions.details"),
          value: "details",
        },
      },
    });

    if (!choice) return;
    if (downloading[id]) return;

    setDownloading((prev) => ({ ...prev, [id]: true }));

    try {
      let endpoint = "";
      let fileName = "";

      if (choice === "gatepass") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-temp-visitor/${id}`;
        fileName = `GatePass_${visitorId}.pdf`;
      } else if (choice === "details") {
        endpoint = `${process.env.REACT_APP_API_URL}download-gatepass-temp-visitor-details/${id}`;
        fileName = `GatePassDetails_${visitorId}.pdf`;
      } else {
        return;
      }

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authkey: process.env.REACT_APP_AUTH_KEY,
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({ lang: localStorage.getItem("lang") }),
      });

      if (!response.ok) {
        toast.error(t("VisitorGatePass.downloadFailed"));
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        toast.success(t("VisitorGatePass.downloadSuccess"));
      }, 100);
    } catch (error) {
      console.error("Download error:", error);
      toast.error(t("VisitorGatePass.somethingWentWrong"));
    } finally {
      setDownloading((prev) => ({ ...prev, [id]: false }));
    }
  };

  // Delete visitor gate pass
  const deleteVisitorGatePass = (id, name) => {
    swal({
      title: t("VisitorGatePass.deleteConfirm", { name }),
      text: t("VisitorGatePass.deleteWarning"),
      icon: "warning",
      buttons: [t("VisitorGatePass.cancel"), t("VisitorGatePass.delete")],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}delete-visitor-gatepass/${id}`,
          {
            method: "DELETE",
            headers: {
              authkey: process.env.REACT_APP_AUTH_KEY,
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          },
        );
        const result = await response.json();
        if (result.code === 200) {
          toast.success(t("VisitorGatePass.deleted"));
          setRows((prev) => prev.filter((item) => item._id !== id));
          setTotal((prev) => prev - 1);
        } else {
          toast.error(result.message || t("VisitorGatePass.deleteFailed"));
        }
      } catch (error) {
        toast.error(t("VisitorGatePass.somethingWentWrong"));
      }
    });
  };

  const getStatusChip = (status) => {
    const statusConfig = {
      pending: { color: "warning", icon: <PendingIcon />, label: t("VisitorGatePass.pending") },
      accept: { color: "success", icon: <AcceptIcon />, label: t("VisitorGatePass.accepted") },
      reject: { color: "error", icon: <RejectIcon />, label: t("VisitorGatePass.rejected") },
    };
    const config = statusConfig[status] || statusConfig.pending;

    return (
      <Chip
        icon={config.icon}
        label={config.label}
        color={config.color}
        size="small"
        variant="outlined"
      />
    );
  };

  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label={t("VisitorGatePass.searchLabel")}
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={t("VisitorGatePass.searchPlaceholder")}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <FormControl fullWidth>
            <InputLabel>{t("VisitorGatePass.statusFilter")}</InputLabel>
            <Select
              value={statusFilter}
              onChange={handleStatusFilter}
              label={t("VisitorGatePass.statusFilter")}
            >
              <MenuItem value="all">{t("VisitorGatePass.allStatus")}</MenuItem>
              <MenuItem value="pending">{t("VisitorGatePass.pending")}</MenuItem>
              <MenuItem value="accept">{t("VisitorGatePass.accepted")}</MenuItem>
              <MenuItem value="reject">{t("VisitorGatePass.rejected")}</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <MainCard
        title={
          <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
            <Grid item>
              <Typography variant="h3">{t("VisitorGatePass.title", { total })}</Typography>
            </Grid>
          </Grid>
        }
        content={false}
      >
        <Card>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer sx={{ maxHeight: 600 }}>
              <Table stickyHeader aria-label="visitor gate pass table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("VisitorGatePass.sNo")}</TableCell>
                    <TableCell>{t("VisitorGatePass.gatePassId")}</TableCell>
                    <TableCell>{t("VisitorGatePass.hodName")}</TableCell>
                    <TableCell>{t("VisitorGatePass.company")}</TableCell>
                    <TableCell>{t("VisitorGatePass.department")}</TableCell>
                    <TableCell>{t("VisitorGatePass.contact")}</TableCell>
                    {/* <TableCell>{t("VisitorGatePass.entryTime")}</TableCell> */}
                    <TableCell>{t("VisitorGatePass.hodStatus")}</TableCell>
                    <TableCell>{t("VisitorGatePass.status")}</TableCell>
                    <TableCell align="center">{t("VisitorGatePass.actions")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("VisitorGatePass.loading")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : rows.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <Typography>{t("VisitorGatePass.noData")}</Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    rows.map((row, index) => (
                      <TableRow hover key={row._id}>
                        <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                        <TableCell>{row.visitorId}</TableCell>
                        <TableCell>{row.staff.name}</TableCell>
                        <TableCell>{row.companyName || "N/A"}</TableCell>
                        <TableCell>{row.department.name || "N/A"}</TableCell>
                        <TableCell>
                          {row.mobile}
                          <br />
                          <Typography variant="caption" color="textSecondary">
                            {row.email}
                          </Typography>
                        </TableCell>
                        {/* <TableCell>
                          <Typography variant="caption">
                            From: {formatDate(row.visitStart)}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            To: {formatDate(row.visitEnd)}
                          </Typography>
                        </TableCell> */}
                        <TableCell>{getStatusChip(row.staff_status)}</TableCell>
                        <TableCell>{getStatusChip(row.status)}</TableCell>
                        <TableCell align="center">
                          <Stack direction="row" spacing={0.5} justifyContent="center">
                            <Tooltip title={t("VisitorGatePass.view")}>
                              <IconButton
                                size="small"
                                color="info"
                                onClick={() => navigate(`/visitor-gatepass/${row._id}`)}
                              >
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            {row.staff_status !== PASS_STATUS.REJECTED &&
                              row.status === PASS_STATUS.PENDING && (
                                <>
                                  <Tooltip title={t("VisitorGatePass.accept")}>
                                    <IconButton
                                      size="small"
                                      color="success"
                                      onClick={() =>
                                        updateVisitorStatus(row._id, "accept", row.visitor.fullName)
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      {updatingStatus[row._id] ? (
                                        <CircularProgress size={16} />
                                      ) : (
                                        <AcceptIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </Tooltip>

                                  <Tooltip title={t("VisitorGatePass.reject")}>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() =>
                                        updateVisitorStatus(row._id, "reject", row.visitor.fullName)
                                      }
                                      disabled={!!updatingStatus[row._id]}
                                    >
                                      <RejectIcon fontSize="small" />
                                    </IconButton>
                                  </Tooltip>
                                </>
                              )}
                            {row.status === PASS_STATUS.ACCEPTED && (
                              <>
                                <Tooltip title={t("VisitorGatePass.sendGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="primary"
                                    onClick={() =>
                                      sendVisitorGatePass(row._id, row.visitor.fullName)
                                    }
                                    disabled={sendingPass}
                                  >
                                    <EmailIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                                <Tooltip title={t("VisitorGatePass.downloadGatePass")}>
                                  <IconButton
                                    size="small"
                                    color="secondary"
                                    onClick={() => handleDownload(row._id, row.visitorId)}
                                    disabled={!!downloading[row._id]}
                                  >
                                    {downloading[row._id] ? (
                                      <CircularProgress size={16} />
                                    ) : (
                                      <DownloadIcon fontSize="small" />
                                    )}
                                  </IconButton>
                                </Tooltip>
                              </>
                            )}
                            <Tooltip title={t("VisitorGatePass.delete")}>
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => deleteVisitorGatePass(row._id, row.visitor.fullName)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50]}
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Card>
      </MainCard>
    </>
  );
}
